import React from 'react'
import { RANKED_COLOR } from 'constant'

export const ordinalSuffixOf = (i: number) => {
  var j = i % 10,
    k = i % 100
  if (j === 1 && k !== 11) {
    return i + 'st'
  }
  if (j === 2 && k !== 12) {
    return i + 'nd'
  }
  if (j === 3 && k !== 13) {
    return i + 'rd'
  }
  return i + 'th'
}

export const CustomizedDot = (props: any) => {
  const WIDTH = 40
  const { cx, cy, value } = props

  return (
    <svg>
      <rect
        x={cx - WIDTH / 2}
        y={cy - WIDTH / 2}
        width={WIDTH}
        height={WIDTH}
        rx={10} // rx is used for border radius in SVG rect
        ry={10} // ry is used for border radius in SVG rect
        fill={getRankingColor(value)}
      />
      <text x={value < 10 ? cx - WIDTH / 5 : cx - WIDTH / 4 - 3} y={cy + WIDTH / 8} fontSize='0.8em' fontWeight={500}>
        {ordinalSuffixOf(value)}
      </text>
    </svg>
  )
}

export const getRankingColor = (value: number) => {
  return RANKED_COLOR[(value - 1) % 5]
}
